import React from "react";
import {
  CardText,
  Button,
} from "reactstrap";
import { FaRegQuestionCircle } from "react-icons/fa";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { copyToClipboard } from '../utils/copyToClipboard';
import DealCarousel from "../components/DealCarousel.js";
import "../css/post.css";
import Parser, { domToReact } from "html-react-parser";
import { storeUrl, amazonCategoryAds } from "../constant";
import axios from "axios";
import Fab from '@material-ui/core/Fab';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useHistory } from 'react-router-dom';
import Translate from "../components/Translate";
import Tooltip from '@material-ui/core/Tooltip';
import CloseIcon from '@material-ui/icons/Close';
import { useFavorite, useCategory, useDstore, useDialog } from '../hooks';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import { saveToStorage, getAllKeys } from '../utils/storage';
import { categoryNames } from '../constant';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import ScrollTop, { GoHome } from "../components/ScrollTop";
import { makeStyles } from '@material-ui/core/styles';
import ReactTooltip from "react-tooltip";
import postscribe from 'postscribe';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    bottom: theme.spacing(10),
    right: theme.spacing(2),
    zIndex: 555,
  },
}));

const Post = (props) => {
  const history = useHistory();
  const [favorites, setFavorites] = useFavorite();
  const [, setCategory] = useCategory();
  const [, setDstore] = useDstore();
  const classes = useStyles();
  const [copyText, setCopyText] = React.useState('');

  const routeChange = React.useCallback(path => {
    history.push(path);
  }, [history]);

  const goBackIcon = history.length > 1 ? (
    <Tooltip title="Go back." arrow placement="top-end">
      <Fab color="primary" aria-label="Go back."
        className={classes.root}
        onClick={() => history.goBack()}>
        <ArrowBackIcon />
      </Fab>
    </Tooltip>
  ) : (<Tooltip title="This is a new window page. You may close it." arrow placement="top-end">
    <Fab color="secondary" aria-label="This is new window. You may close it."
      className={classes.root}
      onClick={() => window.close()}>
      <CloseIcon />
    </Fab>
  </Tooltip>);

  const { deal, setStore, setGuide, setModalOpen, setGuideLoading } = props;
  const { dname, dcpn, dno, dstore, dmore, dprice, dsale, dcontent, dimg, durl, dcat, etitle, dbrand } = deal;
  const storageData = { dno, dname, dimg, durl };

  const goStore = React.useCallback((dstore) => {
    setDstore(dstore);
    routeChange("/store");
  }, [setDstore, routeChange]);

  const goCategory = React.useCallback((cat) => {
    setCategory(cat);
    routeChange("/category");
  }, [setCategory, routeChange]);

  const storeChip = (
    <Chip
      avatar={<Avatar>S</Avatar>}
      key={dstore}
      label={dstore}
      variant="outlined"
      color="secondary"
      className="cursor"
      onClick={() => goStore(dstore)}
    />
  );

  const categorieChip = React.useMemo(() => {
    const dcats = dcat.split(',');
    const catChips = dcats.map(cat => {
      if (cat !== '42' && cat !== '1') {
        return (
          <Chip
            avatar={<Avatar>C</Avatar>}
            key={cat}
            label={categoryNames[cat]}
            variant="outlined"
            color="primary"
            className="cursor"
            onClick={() => goCategory(cat)}
          />
        );
      }
      return null;
    })
    return <React.Fragment>{catChips}</React.Fragment>;
  }, [dcat, goCategory]);

  const save = (data) => {
    saveToStorage(data);
    setFavorites(getAllKeys());
  };

  let itemToFind = etitle ? etitle : dname;
  //const firstSpace = itemToFind.indexOf(' ');
  //const secondSpace = itemToFind.indexOf(' ', 30);
  //itemToFind = itemToFind.substring(0, secondSpace);
  while (itemToFind.indexOf("'") !== -1) {
    itemToFind = itemToFind.replace("'", "");
  }

  // let amazonads = undefined; 
  // dcat.split(',').forEach(cat => {
  //   if (cat !== '42' && cat !== '1') {
  //     amazonads = amazonCategoryAds[cat];
  //   }
  // });
  // amazonads = dbrand ? `<script type="text/javascript">
  // amzn_assoc_placement = "adunit0";
  // amzn_assoc_search_bar = "true";
  // amzn_assoc_tracking_id = "smilegive-20";
  // amzn_assoc_search_bar_position = "bottom";
  // amzn_assoc_ad_mode = "search";
  // amzn_assoc_ad_type = "smart";
  // amzn_assoc_marketplace = "amazon";
  // amzn_assoc_region = "US";
  // amzn_assoc_title = "Shop Related Products";
  // amzn_assoc_default_search_phrase = "`+dbrand+`";
  // amzn_assoc_default_category = "All";
  // amzn_assoc_linkid = "a475034c25f2668a5d73022e1a084141";
  // </script>
  // <script src="//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US"></script>
  // ` : amazonads ? amazonads : `<script type="text/javascript">
  // amzn_assoc_placement = "adunit0";
  // amzn_assoc_search_bar = "true";
  // amzn_assoc_tracking_id = "smilegive-20";
  // amzn_assoc_search_bar_position = "bottom";
  // amzn_assoc_ad_mode = "search";
  // amzn_assoc_ad_type = "smart";
  // amzn_assoc_marketplace = "amazon";
  // amzn_assoc_region = "US";
  // amzn_assoc_title = "Shop Related Products";
  // amzn_assoc_default_search_phrase = "`+itemToFind+`";
  // amzn_assoc_default_category = "All";
  // amzn_assoc_linkid = "a475034c25f2668a5d73022e1a084141";
  // </script>
  // <script src="//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US"></script>
  // `;

  // React.useEffect(() => {
  //   postscribe('#amzn_container', amazonads);
  // }, []);

  const copied = Translate("已複製!");
  const buy = Translate("購買");
  const hasCoupon = dcpn !== "" && dcpn !== null;

  const goCoupon = () => {
    if (!hasCouponInHTML && (dcpn === "" || dcpn === null)) { return; }
    copyToClipboard(dcpn);
    setCopyText(<span style={{color: "red"}} >{copied}</span>);
    setTimeout(() => {
      setCopyText('');
    } , 3000);
  }

  const favoriteIcon = favorites.includes(dno) ? <Tooltip title="已收藏" arrow placement="top-end"><FavoriteIcon color="secondary" /></Tooltip> : <Tooltip title="收藏" arrow placement="top-end"><FavoriteBorderIcon className="cursor" color="primary" onClick={() => save(storageData)} /></Tooltip>;

  const cardMargin = props.cardMargin ?? "10px";

  let hasCouponInHTML = false;

  const dealcpn = (dcpn !== "" && dcpn !== null) ? (
    <>
    <CardText style={{ marginTop: '1rem', marginBottom: '1rem' }}>
      Coupon:{" "}
      <CopyToClipboard text={dcpn}>
        <span
          style={{
            display: "inline",
            fontSize: "1em",
            fontWeight: "bold",
            border: "1px dashed #1068af",
            backgroundColor: "#e2ecf5",
            color: "#00314c",
            padding: "0pt 5pt",
            margin: "1pt",
            borderRadius: "5px",
            cursor: "pointer",
          }}
          onClick={goCoupon}
        >
          {dcpn}
        </span>
      </CopyToClipboard>
        {copyText}
    </CardText>
      </>
  ) : null;

  const getGuide = React.useCallback((store) => {
    setGuideLoading(true);
    const data = new FormData();
    if (!isNaN(store)) {
      data.append("sno", store);
    } else {
      data.append("store", store);
    }
    axios
      .post(storeUrl, data)
      .then((response) => {
        setGuide(response.data.guide);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setGuideLoading(false)
      );
  }, [setGuide, setGuideLoading]);

  const [buttonText, setButtonText] = React.useState("點此展開▼");
  const [hiddenStyle, setHiddenStyle] = React.useState("none");

  const buttonClick = () => {
    if (buttonText === "點此展開▼") {
      setHiddenStyle("block");
      setButtonText("收起▲");
    } else {
      setHiddenStyle("none");
      setButtonText("點此展開▼");
    }
  };

  const htmlParse = (html) => {
    const replace = (domNode) => {
      if (domNode.attribs && domNode.attribs.class === "showmore") {
        return (
          <button className="showmore" onClick={buttonClick}>
            {buttonText}
          </button>
        );
      }
      if (domNode.attribs && domNode.attribs.class === "hiddentext") {
        return (
          <div className="hiddentext" style={{ display: hiddenStyle }}>
            {domToReact(domNode.children, htmlParse)}
          </div>
        );
      }
      if (domNode.attribs && domNode.attribs.class === "cpntxt"){
        hasCouponInHTML = true;
        return (
          <>
          <CopyToClipboard text={domNode.children[0].data}>
        <span
          style={{
            display: "inline",
            fontSize: "1em",
            fontWeight: "bold",
            border: "1px dashed #1068af",
            backgroundColor: "#e2ecf5",
            color: "#00314c",
            padding: "0pt 5pt",
            margin: "1pt",
            borderRadius: "5px",
            cursor: "pointer",
          }}
          onClick={goCoupon}
        >
          {domNode.children[0].data}
        </span>
      </CopyToClipboard>
      {copyText}
      </>
        )
      }
    };
    return Parser(html, { replace });
  };

  return dno ? (
    <React.Fragment>      
      <ScrollTop />
      <GoHome />
      <div
        style={{
          minHeight: "400px",
          margin: cardMargin,
          borderRadius: ".25rem",
          border: "1px solid rgba(0,0,0,.125)",
          padding: "10px",
        }}
        key={dno}
      >
        <h2>{dname && Translate(dname)}</h2>
        <React.Fragment>
          <div style={{ color: "grey", fontSize: "18px", marginBottom: '1rem' }}>
            {storeChip}&nbsp;
            {/* {categorieChip}&nbsp; */}
            <Button
              style={{
                height: "28px",
                padding: "5px",
                fontSize: "16px",
                lineHeight: "0",
                backgroundColor: "#e8e8e8",
                color: "black",
                display: dmore === "" ? "none" : "inline",
              }}
              onClick={() => {
                setStore(dstore);
                getGuide(dmore);
                setModalOpen(true);
              }}
            >
              {Translate('購買指南')} <FaRegQuestionCircle />
            </Button>
            {" "}
            {favoriteIcon}
          </div>
          {dealcpn}
          {dcontent && htmlParse(Translate(dcontent))}
          <div>
            <span style={{ color: "red", textDecoration: "line-through" }}>
              {dprice ? "$" : ""} {dprice}
            </span>
            <span style={{ color: "black", fontWeight: "bold" }}>
              &nbsp;{dsale ? "$" : ""}
              {dsale}
            </span>
          </div>
        </React.Fragment>
      </div>
      <div id="amzn_container" />
      <DealCarousel dcat={dcat} dstore={dstore} setModalOpen={setModalOpen} setStore={setStore} setGuide={setGuide} />
      {goBackIcon}
      
      <ReactTooltip />
    </React.Fragment>
  ) : null;
};

export default Post;
